import http from '../utils';
import { prefix } from '../constants';

/** 版本标题列表 — 板块 B */
export const getVersionTitleList = (payload: any): Promise<any> => {
  return http({
    url: `${prefix}/steam/analysis/title_list`,
    method: 'post',
    ...payload,
  });
};

/** 版本分析列表 — 板块 C */
export const getVersionAnalysisList = (payload: any): Promise<any> => {
  return http({
    url: `${prefix}/steam/analysis/list`,
    method: 'post',
    ...payload,
  });
};

/** 版本时间线数据 — 板块 D */
export const getVersionTimeline = (payload: any): Promise<any> => {
  return http({
    url: `${prefix}/steam/analysis/timeline`,
    method: 'post',
    ...payload,
  });
};
